import { FieldValues, PathValue, Path } from 'react-hook-form';
import { RadioOption } from '../Forms/Fields/RadioField';

export const ContractSigningKindOptionsMap = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  JURIDICAL_PERSON: 'JURIDICAL_PERSON',
} as const;

export type ContractSigningKind = typeof ContractSigningKindOptionsMap[
  keyof typeof ContractSigningKindOptionsMap
];

export class ContractSigningKindOptions {
  static asRadioOptions<T extends FieldValues>() {
    const radioOptions: RadioOption<T>[] = [
      {
        id: ContractSigningKindOptionsMap.NATURAL_PERSON,
        label: 'Persona natural',
        value: ContractSigningKindOptionsMap.NATURAL_PERSON as PathValue<T, Path<T>>,
      },
      {
        id: ContractSigningKindOptionsMap.JURIDICAL_PERSON,
        label: 'Persona jurídica',
        value: ContractSigningKindOptionsMap.JURIDICAL_PERSON as PathValue<T, Path<T>>,
      },
    ];
    return radioOptions;
  }
}
